module.exports = __webpack_public_path__ + "static/media/skill2_neg_es.91bdcb0e.txt";